export const inspectTable = [
  {
    title: "1. 작업장 일반",
    content: "작업장 정리 정돈 및 청결 상태",
    isChecked: "",
  },
  {
    title: "1. 작업장 일반",
    content: "통로확보 및 통행로 물품 적재 및 방치 여부",
    isChecked: "",
  },
  {
    title: "1. 작업장 일반",
    content: "추락위험을 방지할 수 있는 안전시설 설치 여부 (안전난간, 안전 덮개, 방호 울 등)",
    isChecked: "",
  },
  {
    title: "1. 작업장 일반",
    content: "작업장의 조명, 온도, 환기 상태",
    isChecked: "",
  },
  {
    title: "1. 작업장 일반",
    content: "장애물(문턱, 배관, 패인곳) 등에 의한 넘어짐 위험 여부",
    isChecked: "",
  },

  {
    title: "2. 위험 기계기구",
    content: "위험기계기구의 방호장치 설치 및 기능 상태",
    isChecked: "",
  },
  {
    title: "2. 위험 기계기구",
    content: "위험기계기구의 관리대장 작성 및 보관 여부",
    isChecked: "",
  },
  {
    title: "2. 위험 기계기구",
    content: "벨트 등 위험점의 노출 여부",
    isChecked: "",
  },
  {
    title: "2. 위험 기계기구",
    content: "담당자 외의 근로자(무자격자)가 임의 작동 여부",
    isChecked: "",
  },
  {
    title: "2. 위험 기계기구",
    content: "법정 검사 주기 준수 여부",
    isChecked: "",
  },
  {
    title: "2. 위험 기계기구",
    content: "수리 등 비정형 작업시의 안전조치 실시 여부",
    isChecked: "",
  },

  {
    title: "3. 전기",
    content: "전기설비의 절연, 접지 및 관리 상태",
    isChecked: "",
  },
  {
    title: "3. 전기",
    content: "전선의 노후화 및 피복 손상 여부",
    isChecked: "",
  },
  {
    title: "3. 전기",
    content: "정전 및 활선 작업시의 안전조치 및 보호구 착용 여부",
    isChecked: "",
  },

  {
    title: "4. 소화설비 관리",
    content: "소화설비(소화기, 소화전) 설치 및 관리 상태",
    isChecked: "",
  },
  {
    title: "4. 소화설비 관리",
    content: "소화전 주변 물건 적재 여부",
    isChecked: "",
  },

  {
    title: "5. 보호구 착용 상태",
    content: "작업 조건에 맞는 보호구를 지급·착용확인\n※ 안전모, 안전대, 안전화, 보안경, 보안면, 절연용 보호구, 방열복, 방진·방독마스크 등",
    isChecked: "",
  },
  {
    title: "5. 보호구 착용 상태",
    content: "보호구 보관 시 정리 정돈 및 보호구 지급대장 작성 여부\n",
    isChecked: "",
  },

  {
    title: "6. 중량물 취급",
    content: "5kg 이상의 중량물 작업 시 중량과 무게중심 표지 부착",
    isChecked: "",
  },
  {
    title: "6. 중량물 취급",
    content: "중량물 작업 시 올바른 작업자세 및 작업도구 지급 여부",
    isChecked: "",
  },

  {
    title: "7. 안전보건표지",
    content: "안전보건표지 부착 및 관리상태",
    isChecked: "",
  },

  {
    title: "8. 유해화학물질",
    content: "물질안전보건자료(MSDS) 게시 및 보관 여부",
    isChecked: "",
  },
  {
    title: "8. 유해화학물질",
    content: "물질안전보건자료(MSDS) 교육 실시 여부",
    isChecked: "",
  },
  {
    title: "8. 유해화학물질",
    content: "소분 용기에 경고 표지 부착 여부",
    isChecked: "",
  },

  {
    title: "9. 보건관리",
    content: "근로자들의 전반적인 건강 상태",
    isChecked: "",
  },
  {
    title: "9. 보건관리",
    content: "응급구급함 지급 및 관리 상태",
    isChecked: "",
  },

  {
    title: "10. 밀폐공간",
    content: "작업 전 밀폐공간 내 산소농도/유해가스 농도 측정",
    isChecked: "",
  },
  {
    title: "10. 밀폐공간",
    content: "작업 전 안전모 산소호흡기 등 보호구 착용 여부",
    isChecked: "",
  },
  {
    title: "10. 밀폐공간",
    content: "작업 전 밀폐공간 작업허가서 승인 여부",
    isChecked: "",
  },

  {
    title: "11. 고열 · 한랭 작업",
    content: "고열·한랭 작업시 보호구 지급 여부",
    isChecked: "",
  },
  {
    title: "11. 고열 · 한랭 작업",
    content: "작업시간 내 휴게시간 편성 여부",
    isChecked: "",
  },
];
